<template>
    <div id="work" v-if="work.lavoro">
        <div class="preview" :style="'background-image: url(\''+work.lavoro.imgPreview+'\')'">
            <img :src="work.lavoro.logoAzienda" alt="">
        </div>
        <div class="name">{{work.lavoro.name}}</div>
        <div class="desc">{{work.lavoro.desc}}</div>
        <Mosaico :files="mapForMosaico(work.files)"/>
    </div>
</template>

<script>
import axios from 'axios';
import Mosaico from '../components/Mosaico'
export default {
    components:{Mosaico},
    data() {
        return {
            work: {},
        }
    },
    methods:{
        getQueryVariable(variable){
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
            }
            return(false);
        },
        mapForMosaico(files){
            return files.map((file)=>{
                return {file: file.fotoUrl}
            })
        }
    },
    created(){
        var params = new URLSearchParams();
        params.append('id', this.getQueryVariable('id'));
        axios.post('https://www.matteortili.com/scripts/fetchLavoro.php',params).then((response)=>{
            var res = response.data;
            this.work = res;
        })
    }
}
</script>

<style scoped>
#work{
    max-width: 900px;
    margin: 100px auto 50px auto;
}
.preview{
    width: 100%;
    height: 500px;
    background-size: cover;
    background-position: center center;
    border-radius: 1rem;
    position: relative;
}
.preview > img{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 80%;
    max-height: 80%;
    backdrop-filter: blur(8px);
    background-color: rgba(255, 255, 255, 0.315);
    padding: 1rem;
    border-radius: 1rem;
}
.name{
    font-size: 40pt;
    font-weight: 500;
}
.desc{
    padding: 1rem;
    margin: 0rem 1rem 3rem 1rem;
    border: 1px solid white;
    border-radius: 1rem;
}
</style>